import { render, staticRenderFns } from "./type-textarea.vue?vue&type=template&id=a15bae44&scoped=true&"
import script from "./type-textarea.vue?vue&type=script&lang=js&"
export * from "./type-textarea.vue?vue&type=script&lang=js&"
import style0 from "./type-textarea.vue?vue&type=style&index=0&id=a15bae44&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15bae44",
  null
  
)

export default component.exports